import { render, staticRenderFns } from "./app-scroll-top.vue?vue&type=template&id=bedeae96&"
import script from "./app-scroll-top.vue?vue&type=script&lang=js&"
export * from "./app-scroll-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports